import { i18nKeys } from 'translationTypes'
import { IStepByStep } from './StepByStep'

export enum AbnStepByStep {
  ABN_APPLY = 1,
  ABN_ENTITLEMENT,
  APPLICATION_DETAILS,
  BUSINESS_INFO,
  REASON_FOR_APPLY,
  DECLARATION,
}

type AbnStepByStepConfigType = {
  [key in AbnStepByStep]: IStepByStep
}

const IMAGE_LINKS = {
  1: 'step-1-abn-apply.jpg',
  2: 'step-2-abn-entitlement.jpg',
  3: 'step-3-application-detail.jpg',
  40: 'step-4-taxation-info.jpg',
  41: 'step-41-applicant-info.jpg',
  42: 'step-42-business-activity.jpg',
  43: 'step-43-business-location.jpg',
  44: 'step-44-contact-details.jpg',
  5: 'step-5-reason-to-apply.jpg',
  6: 'step-6-declaration.jpg',
}

export const config: AbnStepByStepConfigType = {
  [AbnStepByStep.ABN_APPLY]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step1__title,
    image: IMAGE_LINKS[1],
    instructions: [i18nKeys.backgroundCheck__abnHowTo__step1__instruction],
  },
  [AbnStepByStep.ABN_ENTITLEMENT]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step2__title,
    image: IMAGE_LINKS[2],
    instructions: [i18nKeys.backgroundCheck__abnHowTo__step2__instruction],
    bullets: [
      i18nKeys.backgroundCheck__abnHowTo__step2__bullet1,
      i18nKeys.backgroundCheck__abnHowTo__step2__bullet2,
      i18nKeys.backgroundCheck__abnHowTo__step2__bullet3,
      i18nKeys.backgroundCheck__abnHowTo__step2__bullet4,
      i18nKeys.backgroundCheck__abnHowTo__step2__bullet5,
    ],
  },
  [AbnStepByStep.APPLICATION_DETAILS]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step3__title,
    image: IMAGE_LINKS[3],
    instructions: [i18nKeys.backgroundCheck__abnHowTo__step3__instruction],
    bullets: [
      i18nKeys.backgroundCheck__abnHowTo__step3__bullet1,
      i18nKeys.backgroundCheck__abnHowTo__step3__bullet2,
    ],
  },
  [AbnStepByStep.BUSINESS_INFO]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step4__title,
    sections: [
      {
        title: i18nKeys.backgroundCheck__abnHowTo__step41__title,
        image: IMAGE_LINKS[40],
        instructions: [i18nKeys.backgroundCheck__abnHowTo__step41__instruction],
        bullets: [
          i18nKeys.backgroundCheck__abnHowTo__step41__bullet1,
          i18nKeys.backgroundCheck__abnHowTo__step41__bullet2,
        ],
      },
      {
        title: i18nKeys.backgroundCheck__abnHowTo__step42__title,
        image: IMAGE_LINKS[41],
        instructions: [i18nKeys.backgroundCheck__abnHowTo__step42__instruction],
      },
      {
        title: i18nKeys.backgroundCheck__abnHowTo__step43__title,
        image: IMAGE_LINKS[42],
        instructions: [i18nKeys.backgroundCheck__abnHowTo__step43__instruction],
        bullets: [
          i18nKeys.backgroundCheck__abnHowTo__step43__bullet1,
          i18nKeys.backgroundCheck__abnHowTo__step43__bullet2,
        ],
      },
      {
        title: i18nKeys.backgroundCheck__abnHowTo__step44__title,
        image: IMAGE_LINKS[43],
        instructions: [i18nKeys.backgroundCheck__abnHowTo__step44__instruction],
      },
      {
        title: i18nKeys.backgroundCheck__abnHowTo__step45__title,
        image: IMAGE_LINKS[44],
        instructions: [i18nKeys.backgroundCheck__abnHowTo__step45__instruction],
      },
    ],
  },
  [AbnStepByStep.REASON_FOR_APPLY]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step5__title,
    image: IMAGE_LINKS[5],
    instructions: [i18nKeys.backgroundCheck__abnHowTo__step5__instruction],
  },
  [AbnStepByStep.DECLARATION]: {
    title: i18nKeys.backgroundCheck__abnHowTo__step6__title,
    image: IMAGE_LINKS[6],
    instructions: [
      i18nKeys.backgroundCheck__abnHowTo__step6__instruction1,
      i18nKeys.backgroundCheck__abnHowTo__step6__instruction2,
    ],
  },
}
